import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "StatisticsRetained" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {modalConfig} from './config/modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {ref} from 'vue'
import {usePageModal} from '@/hooks/usePageModal'
import dayjs from 'dayjs'
import {useStore} from '@/store'
import {getPageListData} from '@/service/main/system'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsRetained',
  setup(__props) {

const store = useStore()
const userInfo = store.state.login.userInfo

const otherInfo = ref({})

const modalTitle = ref('新增时间配置')

const queryParam = {
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const getEventList = async () => {
  let roleData = await getPageListData(
    '/main/customerEvents/queryByCondition',
    {
      pageNo: 1,
      pageSize: 1000
    }
  )

  const events = modalConfig.formItems.find((item) => item.field === 'channelId')
  const channels = searchFormConfig.formItems.find((item) => item.field === 'channelId')

  channels!.options = roleData.list.map((item: any) => {
    return {title: item.eventName, value: item.rowId}
  })

  events!.options = roleData.list.map((item: any) => {
    return {title: item.eventName, value: item.rowId}
  })
}
getEventList()

const resetCb = () => {
  return queryParam
}

const [pageModalRef, defaultInfo, handleNewData] = usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "liveRetainedStatistics",
      deleteTip: "确认删除此时间配置吗？",
      downFilename: "直播间留存统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onNewBtnClick: _unref(handleNewData),
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig", "onDownBtnClick", "onNewBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "liveRetainedStatistics",
      otherInfo: otherInfo.value,
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})